import React from "react";
import Fallback from "../../components/Fallback";

const Campaigns = React.lazy(() => import("./Campaigns"));
export const CampaignsScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Campaigns {...props} />
  </React.Suspense>
);

const CampaignsDetail = React.lazy(() => import("./CampaignsDetail"));
export const CampaignsDetailScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <CampaignsDetail {...props} />
  </React.Suspense>
);
